module.exports = __webpack_public_path__ + "media/packs/images/flags/EE-9d6b034f9922d58485defcc1762a9cd8.png";